import * as angular from "angular";
import * as moment from "moment";
import * as _ from "lodash";
import * as dynamicNumber from "angular-dynamic-number";
import bugsnagClient from "./bugsnag";

import { notifyjsModule } from "./app/common/wrappers/angular-notifyjs";
import { Constants } from "./constants";
import { AuthService as authService } from "./app/common/auth.service";
import { ReportingService as reportingService } from "./app/common/reporting.service";
import { HealthService as healthService } from "./app/health/health.service";
import { login } from "./app/login/login.controller";
import { logoutDialog } from "./app/common/logout-dialog/logout-dialog";
import { loginDialog } from "./app/login/login-dialog/login-dialog";
import { portfolioModule } from "./app/portfolio/portfolio.index";
import { portfolioadminModule } from "./app/portfolioadmin/portforlioadmin.index";
import { performanceModule } from "./app/performance/performance.index";
import { reportsModule } from "./app/reports/reports.index";
import routesConfig from "./routes";
import { main } from "./app/main";
import { header } from "./app/layout/header";
import { footer } from "./app/layout/footer";
import { navigation } from "./app/layout/navigation";
import { contactusModule } from "./app/contactus/contactus.index";
import { transactionsModule } from "./app/transactions/transactions.index";
import { clientsModule } from "./app/clients/clients.index";
import { cModelModule } from "./app/cmodel/cmodel.index";
import { tradingModule } from "./app/trading/trading.index";
import { simulationsModule } from "./app/simulations/simulations.index";
import { tradingAdminModule } from "./app/tradingadmin/tradingAdmin.index";
import { feesModule } from "./app/fees/fees.index";
import { usersModule } from "./app/users/users.index";
import { reportingModule } from "./app/reporting/reporting.index";
import { portfolioManagementModule } from "./app/portfoliomanagement/portfoliomanagent.index";
import "./index.scss";
import { ExchangeService } from "./app/common/services/exchange.service";
import { bulkEmailingModule } from "./app/bulkemailing/bulkemailing.index";
import { Roles } from "./app/common/enums/Roles";
import { complianceModule } from "./app/compliance/compliance.index";
import { termsConditions } from "./app/common/terms-conditions/termsConditions.dialog";
import { filesModule } from "./app/fileprovider/fileprovider.index";
import { clientApplicationModule } from "./app/onboarding/clientapplication.index";
import { clientViewModule } from "./app/onboarding/client/clientview.index";
import { registeredClientModule } from "./app/onboarding/registeredClient/registeredclient.index";
import { communicationModule } from "./app/communications/communication.index";

angular
  .module("app", [
    "angular-jwt",
    notifyjsModule,
    performanceModule,
    portfolioModule,
    contactusModule,
    transactionsModule,
    clientsModule,
    portfolioadminModule,
    cModelModule,
    tradingModule,
    tradingAdminModule,
    usersModule,
    reportsModule,
    reportingModule,
    portfolioManagementModule,
    simulationsModule,
    feesModule,
    bulkEmailingModule,
    dynamicNumber,
    complianceModule,
    filesModule,
    clientApplicationModule,
    clientViewModule,
    registeredClientModule,
    communicationModule,
    "exceptionOverride",
    "ngQuill",
    "ui.router",
    "ui.bootstrap",
    "ngCookies",
    "ngSanitize",
    "ngFilesizeFilter",
    "ncy-angular-breadcrumb",
    "LocalStorageModule",
    "ngMaterial",
    "ngMessages",
  ])

  .config(routesConfig)
  .config(function ($breadcrumbProvider) {
    $breadcrumbProvider.setOptions({
      template: `<div>
      <span ng-repeat="step in steps" ng-class="{active: $last}" ng-switch="$last || !!step.abstract">
      <span ng-if="!$first"> <i class="material-icons">keyboard_arrow_right</i> </span>      <a ng-switch-when="false" href="{{step.ncyBreadcrumbLink}}">{{step.ncyBreadcrumbLabel}}</a>
    <span ng-switch-when="true">{{step.ncyBreadcrumbLabel}}</span></span></div>`,
    });
  })
  .config([
    "localStorageServiceProvider",
    function (localStorageServiceProvider) {
      localStorageServiceProvider.setPrefix("arkanoid");
    },
  ])
  .config([
    "dynamicNumberStrategyProvider",
    function (dynamicNumberStrategyProvider) {
      dynamicNumberStrategyProvider.addStrategy("percentage", {
        numInt: 3,
        numFract: 2,
        numSep: ".",
        numPos: true,
        numNeg: false,
        numFixed: true,
      });
      dynamicNumberStrategyProvider.addStrategy("price", {
        numInt: 20,
        numFract: 4,
        numSep: ".",
        numPos: true,
        numNeg: true,
        numThousand: true,
      });
      dynamicNumberStrategyProvider.addStrategy("quantity", {
        numInt: 10,
        numFract: 0,
        numSep: ".",
        numPos: true,
        numNeg: true,
        numThousand: true,
      });
    },
  ])
  .config([
    "cfpLoadingBarProvider",
    function (cfpLoadingBarProvider) {
      cfpLoadingBarProvider.parentSelector = "#loader";
      cfpLoadingBarProvider.includeSpinner = false;
    },
  ])
  .config([
    "$httpProvider",
    function ($httpProvider: angular.IHttpProvider, loginDialog) {
      $httpProvider.interceptors.push([
        "$q",
        "notifyjs",
        "$injector",
        ($q, notifyjs, $injector) => {
          return {
            responseError: (rejection) => {
              if (rejection && rejection.status !== 400) {
                if (rejection.xhrStatus == "error") {
                  notifyjs(
                    "Unfortunately the system has encountered an issue. Please check your internet connection.",
                    "error"
                  );
                } else {
                  switch (rejection.status) {
                    case 401: {
                      notifyjs(
                        "The user session has timed out. Please login again to continue.",
                        "warning"
                      );
                      $injector.get("authService").openLoginDialog();
                      break;
                    }
                    case 403: {
                      notifyjs(
                        "Unfornately you don't have the correct rights to perform this action.",
                        "warning"
                      );
                      break;
                    }
                    case 500: {
                      notifyjs(
                        "Unfortunately the system has encountered an issue. Please contact the system administrator for further assistance.",
                        "error"
                      );
                      break;
                    }
                    case 502:
                    case -1: {
                      notifyjs(
                        "The Confident Portal is currently not available. We are working to solve the issue as soon as possible. Thank you for your patience.",
                        "error"
                      );
                      break;
                    }
                    default: {
                      notifyjs(rejection.data, "error");
                      break;
                    }
                  }
                }
              }
              return $q.reject(rejection);
            },
          };
        },
      ]);
    },
  ])
  .config(function ($mdDateLocaleProvider) {
    $mdDateLocaleProvider.formatDate = function (date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    };
  })
  .service("healthService", healthService)
  .service("authService", authService)
  .service("reportingService", reportingService)
  .service("exchangeService", ExchangeService)
  .component("app", main)
  .component("headerComponent", header)
  .component("footerComponent", footer)
  .component("navigation", navigation)
  .component("login", login)
  .component("logoutDialog", logoutDialog)
  .component("loginDialog", loginDialog)
  .component("termsConditions", termsConditions)
  .constant("config", Constants.Default)
  .directive("eChart", function () {
    return {
      restrict: "A",
      compile: function (tElement, tAttrs, transclude) {
        return {
          pre: function preLink(scope, iElement, iAttrs, controller) {
            scope[iAttrs.eChart] = iElement;
          },
        };
      },
    };
  })
  .run(function (
    $rootScope: angular.IRootScopeService,
    $http: angular.IHttpService,
    authService: authService,
    jwtHelper,
    $location: angular.ILocationService
  ) {
    function setIdTokenFromUrl(url: string) {
      let paramsIndex = url.indexOf("?");
      if (paramsIndex >= 0) {
        let paramsString = url.substr(paramsIndex + 1);
        if ("URLSearchParams" in window) {
          var searchParams = new URLSearchParams(paramsString);

          if (searchParams.has("id_token"))
            authService.setIdToken(searchParams.get("id_token"));
        } else {
          const idToken = paramsString
            .split("&")
            .find((param) => param.startsWith("id_token"));
          if (idToken) authService.setIdToken(idToken.split("=")[1]);
        }
      }
    }

    setIdTokenFromUrl($location.url());
    const setupPromise = authService.setAuthDetails();
    const bearerToken = authService.getIdToken();
    if (!bearerToken) {
      let loginPath = "/login";
      let clientPath = "/clientonboarding";
      const currentPath = $location.path();
      if (
        currentPath !== "/" &&
        currentPath !== loginPath &&
        currentPath !== clientPath
      ) {
        $location.path(loginPath).search({ redirectUrl: currentPath });
      } else if (currentPath !== clientPath) {
        $location.path(loginPath);
      }
    } else {
      $http.defaults.headers.common["Authorization"] = `Bearer ${bearerToken}`;
    }

    $rootScope.$on(
      "$locationChangeStart",
      function (event: angular.IAngularEvent, newUrl: string) {
        setIdTokenFromUrl(newUrl);
        if (authService.hasSignedIn()) {
          let token = authService.getIdToken();
          if (!jwtHelper.isTokenExpired(token)) {
            if (location.pathname === "/") {
              let roles = authService.getUserRoles();

              if (
                _.indexOf(roles, Roles.PortfolioTeam) > -1 ||
                _.indexOf(roles, Roles.SeniorManagement) > -1 ||
                _.indexOf(roles, Roles.SystemAdministrator) > -1 ||
                _.indexOf(roles, Roles.ViewOnly) > -1
              ) {
                $location.path("/portfolioManagement");
              } else if (_.indexOf(roles, Roles.UserAdministrator) > -1) {
                $location.path("/users");
              } else if (_.indexOf(roles, Roles.Client) > -1) {
                $location.path("/portfolio/portfolioSummary");
              } else if (
                _.indexOf(roles, Roles.Accountant) > -1 ||
                _.indexOf(roles, Roles.SeniorAccountant) > -1
              ) {
                $location.path("/fees");
              } else if (_.indexOf(roles, Roles.FinancialAnalyst) > -1) {
                $location.path("/cmodel");
              }
            }
            setupPromise.then(() => authService.renewAuth()); // need to get WORKING!!!
          } else {
            // checking to see that if the token is expired and the path is empty then redirect
            // the user to the login page.
            let path = $location.path();
            if (path === "/login" || path === "/") {
              $location.path("/login");
            } else if (path !== "/clientonboarding") {
              authService.openLoginDialog();
            }
          }
        } else {
          if (location.pathname !== "/clientonboarding") {
            $location.path("/login");
          }
        }
      }
    );
  });

angular
  .module("exceptionOverride", [])
  .factory("$exceptionHandler", function (): angular.IExceptionHandlerService {
    return function (exception: Error, cause: string) {
      console.log(exception, cause);
      bugsnagClient.notify(exception, {
        beforeSend: function (report) {
          report.updateMetaData("angular", { cause: cause });
        },
      });
    };
  });



// WEBPACK FOOTER //
// ./src/index.ts